import ShipAddressValidator from "components/ShipAddressValidator/ShipAddressValidator";
import Spinner from "components/Spinner";
import { setNotification } from "features/Notification/notificationSlice";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import authHeader from "services/auth-header";
import API from "services/axios";

export default function CustomerAddressAddUpdate({
  selectedCustomer,
  formData,
  setFormData,
  isUpdateMode,
  setIsUpdateMode,
  showModal,
  refreshFunc,
  setDefaultShipAddress,
}) {
  /*   All States
   ********************************************* */
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user?.userInfo);

  const [loading, setLoading] = useState(false);

  /*   All Functions
   ********************************************* */
  const handleCopyBillingAddress = () => {
    let shippingAddressData = {
      companyName: selectedCustomer?.addressCompany,
      addressLine1: selectedCustomer?.addressLine1,
      addressLine2: selectedCustomer?.addressLine2,
      city: selectedCustomer?.addressCity,
      state: selectedCustomer?.addressState,
      zip: selectedCustomer?.addressZipCode,
      country: selectedCustomer?.addressCountry,
    };
    setFormData((prevData) => ({
      ...prevData,
      ...shippingAddressData,
    }));

    // Logic to copy billing address to shipping address
  };

  // Adds Button Function
  const handleAddCustomerAddress = async (e, address, checkMarks) => {
    e.preventDefault();

    let body = {
      companyName: address.companyName || "",
      addressLine1: address.addressLine1 || "",
      addressLine2: address.addressLine2 || "",
      city: address.city || "",
      state: address.state || "",
      zip: address.zip || "",
      country: address.country || "",
      addressType: address.addressType || "",
      addressGroundTransitDays: address.addressGroundTransitDays || null,
      authorizePerson: address.authorizePerson || "",
      authorizeLocation: address.authorizeLocation || "",
      serviceId: address.serviceId || "",
      addressDhlTransitDays: address.addressDhlTransitDays || null,
      signatureRelease: checkMarks?.signatureRelease || false,
      selfCollect: checkMarks?.selfCollect || false,
    };

    // return;
    try {
      setLoading(true);
      const { data } = await API.post(
        "/customer-address/add/" + selectedCustomer?.customerId,
        body,
        {
          headers: authHeader(),
        }
      );
      if (data?.success) {
        // after add refresh current page (or go to first page)
        setFormData({});
        showModal(false);
        // Refresh list
        refreshFunc({ page: 1 });
      } else {
        dispatch(setNotification({ message: data?.message, type: "error" }));
      }
    } catch (err) {
      dispatch(setNotification({ message: err.message, type: "error" }));
    } finally {
      setLoading(false);
    }

    showModal(false);
  };

  // Update Button Function
  const handleUpdateCustomerAddress = async (e, address, checkMarks) => {
    e.preventDefault();

    let body = {
      addressId: address.addressId,
      id: address.id,
      companyName: address.companyName || "",
      addressLine1: address.addressLine1 || "",
      addressLine2: address.addressLine2 || "",
      city: address.city || "",
      state: address.state || "",
      zip: address.zip || "",
      country: address.country || "",
      addressType: address.addressType || "",
      addressGroundTransitDays: address.addressGroundTransitDays || null,
      authorizePerson: address.authorizePerson || "",
      authorizeLocation: address.authorizeLocation || "",
      serviceId: address.serviceId || "",
      addressDhlTransitDays: address.addressDhlTransitDays || null,
      signatureRelease: checkMarks?.signatureRelease || false,
      selfCollect: checkMarks?.selfCollect || false,
    };

    try {
      setLoading(true);
      const { data } = await API.patch(
        "/customer-address/" + selectedCustomer?.customerId,
        body,
        {
          headers: authHeader(),
        }
      );
      if (data?.success) {
        setIsUpdateMode(false);
        showModal(false);
        // refresh list
        refreshFunc();
      } else {
        dispatch(setNotification({ message: data?.message, type: "error" }));
      }
    } catch (err) {
      dispatch(setNotification({ message: err.message, type: "error" }));
    } finally {
      setLoading(false);
    }
  };

  /*   All UseEffects
   ********************************************* */
  return (
    <div>
      {loading && <Spinner />}
      <div className="d-flex align-items-center justify-content-between">
        <h3>{isUpdateMode ? " Update Address " : " Add Address "}</h3>
        <div className="d-flex align-items-center justify-content-between gap-2">
          <div>
            <button
              onClick={handleCopyBillingAddress}
              className="btn btn-info btn-sm"
            >
              Copy Billing Address
            </button>
          </div>

          {(user?.permissions?.includes("customer_delete") ||
            user?.roles === "admin") &&
            isUpdateMode &&
            !formData?.isDefault && (
              <button
                type="button"
                onClick={(e) => {
                  setDefaultShipAddress(formData);
                }}
                className="btn btn-sm my-1 me-1 btn-sm btn-success"
              >
                Set As Default
              </button>
            )}
        </div>
      </div>
      <hr className="mt-0 mb-3" />

      <ShipAddressValidator
        isAddMode={!isUpdateMode}
        shippingAddress={formData}
        showModal={showModal}
        submitFunction={
          isUpdateMode ? handleUpdateCustomerAddress : handleAddCustomerAddress
        }
      />
    </div>
  );
}
